import {
  getUserInfo,
  login,
  logout,
  getLotteryLongQueue
} from "../service/user";

export const state = {
  page: "home",
  dialog: {
    type: 1,
    title: "标题",
    data: {}
  },
  theme: localStorage.getItem("theme") || 2,
  user: {},
  lotteryLongQueueData: [],
  selectedDantuoData: {},
  selectedShengxiaoPlayRadio: 1 // 生肖玩法 1.单注 2.胆拖 3… 4…
};

export const actions = {
  // 存储下单时的 胆拖数据
  setSelectedDantuoData({commit}, data) {
    commit("SET_SELECTED_DANTUO_DATA", data);
  },
  // 存储有胆拖玩法的 radio类型
  setSelectedShengxiaoPlayRadio({commit}, data) {
    commit("SET_SELECTED_SHENGXIAO_PALY_RADIO", data);
  },
  changeMainTheme({commit}, type) {
    localStorage.setItem("theme", type);
    commit("CHANGE_MAIN_THEME", type);
  },
  setDialogRef({commit}, el) {
  },

  async updateUserInfo({commit}) {
    const info = await getUserInfo();
    commit("SET_USER_INFO", info);
    return info;
  },

  getUserInfo({dispatch}) {
    if (state.user.uid) return state.user;
    return dispatch("updateUserInfo");
  },

  async login({commit}, info = {}) {
    const res = await login(info);
    if (res.result !== "ok") return res;
    return res;
  },

  async logout({commit}) {
    const info = await logout();
    if (info.result !== "ok") return;
    localStorage.removeItem("token");
    commit("CLEAR_USER_INFO");

    return true;
  },
  // 长龙
  async getLotteryLongQueue({commit}, params) {
    //番摊不请求长龙
    if(params.lottery_type!=19){
      const info = await getLotteryLongQueue(params);
      if (info.result !== "ok") return;
      commit("SAVE_LONGQUEUE_INFO", info);
    }
    return true;
  }
};

export const mutations = {
  ["CHANGE_MAIN_THEME"](state, type) {
    state.theme = type;
  },
  ["SET_USER_INFO"](state, info) {
    state.user = info;
  },
  ["CLEAR_USER_INFO"](state) {
    state.user = {};
  },
  ["SAVE_LONGQUEUE_INFO"](state, info) {
    state.lotteryLongQueueData = info.data;
  },
  ["SET_SELECTED_DANTUO_DATA"](state, info) {
    state.selectedDantuoData = info;
  },
  ["SET_SELECTED_SHENGXIAO_PALY_RADIO"](state, info) {
    state.selectedShengxiaoPlayRadio = info;
  }
};

export const getters = {
  theme: state => state.theme
};



// WEBPACK FOOTER //
// ./src/pages/store.js